if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      if (this.checkPosition) window.removeEventListener('scroll', this.checkPosition);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);

      // BRN 10/29: the observer only fires when the form crosses the viewport edge, so a fast
      // fling, anchor jump or reload below the form left the panel hidden on mobile.
      // Re-check the form position on scroll as well.
      new MutationObserver(() => this.syncChat()).observe(this, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', () => this.syncChat());

      this.checkPosition = this.checkPosition.bind(this);
      window.addEventListener('scroll', this.checkPosition, { passive: true });
      this.checkPosition();

      // BRN 10/29: the panel button adds the selected variant via the main form's own button,
      // so variant, quantity and the Appstle subscription choice all carry over.
      const addBtn = this.querySelector('[data-sticky-atc-add]');
      if (addBtn && this.productForm) {
        addBtn.addEventListener('click', () => {
          const mainBtn = this.productForm.querySelector('button[name="add"]');
          if (mainBtn) mainBtn.click();
        });
      }
      this.productSection.addEventListener('on:variant:change', (evt) => {
        const label = this.querySelector('[data-sticky-atc-variant]');
        if (label && evt.detail && evt.detail.variant) label.textContent = evt.detail.variant.title;
        const mainPrice = this.productInfo && this.productInfo.querySelector('.price');
        const panelPrice = this.querySelector('.price');
        if (mainPrice && panelPrice) panelPrice.innerHTML = mainPrice.innerHTML;
      });
    }

    /**
     * BRN 10/29: lift the Shopify Inbox chat launcher above the panel while the panel shows,
     * so it never covers the Add to cart button. Only the launcher inside Shopify's open
     * shadow root is moved; if the chat markup changes this quietly does nothing.
     */
    syncChat() {
      const chat = document.querySelector('shopify-chat');
      const root = chat && chat.shadowRoot;
      const launcher = root && (root.querySelector('.activator-nudge') || root.querySelector('.activator'));
      if (!launcher) return;
      // Measure the launcher at its untransformed spot (no transition), then place it.
      launcher.style.transition = 'none';
      launcher.style.transform = '';
      if (this.classList.contains('sticky-atc-panel--out')) return;
      const cs = getComputedStyle(this);
      const panelBottom = window.innerHeight - parseFloat(cs.bottom || 0) - parseFloat(cs.marginBottom || 0);
      const panelTop = panelBottom - this.offsetHeight;
      const p = this.getBoundingClientRect();
      const l = launcher.getBoundingClientRect();
      const overlapsX = l.right > p.left && l.left < p.right;
      if (overlapsX && l.bottom > panelTop - 8) {
        launcher.style.transform = 'translateY(' + -Math.ceil(l.bottom - panelTop + 8) + 'px)';
      }
    }

    checkPosition() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.syncChat();
        if (!this.productForm || theme.mediaMatches.md) return;
        this.classList.toggle('sticky-atc-panel--out', this.productForm.getBoundingClientRect().bottom > 0);
      });
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
